import { apiAxios } from "./axios";

export interface VersionInfo {
  version: string;
  git_commit: string;
  git_branch: string;
  deployment_timestamp: string;
  environment: string;
}

class VersionService {
  async getVersion(): Promise<VersionInfo> {
    try {
      const response = await apiAxios.get<VersionInfo>("/version");
      return response.data;
    } catch (error) {
      console.error("Failed to fetch version:", error);
      return {
        version: "unknown",
        git_commit: "unknown",
        git_branch: "unknown",
        deployment_timestamp: "unknown",
        environment: "unknown"
      };
    }
  }
}

export default new VersionService();